import { useState, useEffect, useContext } from "react"
import { getStoryblokApi } from "@storyblok/react"

import { ArticleCategoryStoryToObject } from "../helpers/storyHelpers"
import { LanguageContext } from "../context/languagecontext"

// Is language sensitive
function useStoryblokCategories() {
  const [categories,setCategories] = useState({})
  const language = useContext(LanguageContext)

  useEffect(()=>{
    if(!categories[language]) {
      const storyblokApi = getStoryblokApi()
      storyblokApi.get("cdn/stories", { 
        version: process.env.STORYBLOK_API_CONTENT_VERSION,
        language: language,
        filter_query: { component: { in: "category" } }
      }).then(({ data })=>{
        if(data && data.stories && data.stories.length > 0) {
          setCategories({
            ...categories,
            [language]: data.stories
          })
        }
      }).catch((err)=>{
        console.error(err)
      })
    }
  }, [])

  return categories[language] || []
}

/// Not language specific
function useCategoriesDatasource() {
  const [categories,setCategories] = useState([])

  useEffect(()=>{
    const storyblokApi = getStoryblokApi()
    storyblokApi.get("cdn/datasource_entries", { 
      version: process.env.STORYBLOK_API_CONTENT_VERSION,
      datasource: "categories" // Slug of the datasource
    }).then(({ data })=>{
      if(data && data.stories && data.stories.length > 0) {
        setCategories(data.stories)
      }
    }).catch((err)=>{
      console.error(err)
    })
  }, [])

  return categories
}

function useSingleArticleCategoryByDatasource(datasource) {
  const language = useContext(LanguageContext)
  const [category,setCategory] = useState()

  useEffect(()=>{
    if(datasource) {
      const storyblokApi = getStoryblokApi()
      storyblokApi.get("cdn/stories", { 
        version: process.env.STORYBLOK_API_CONTENT_VERSION,
        content_type: "category",
        filter_query: {
          "category": {
            in: datasource
          }
        }
      }).then(({ data })=>{
        if(data && data.stories && data.stories.length > 0) {
          let rightVersion = data.stories.find((s)=>{
            return s.full_slug.startsWith(language)
          })
          if(rightVersion) {
            setCategory(rightVersion)
          } else {
            rightVersion = data.stories.find((s)=>{
              return s.full_slug.startsWith("en")
            })
            if(rightVersion) {
              setCategory(rightVersion)
            }
          }
        }
      }).catch((err)=>{
        console.error(err)
      })
    }
  },[datasource])

  return category
}

export { 
  useStoryblokCategories,
  useCategoriesDatasource,
  useSingleArticleCategoryByDatasource
}